import { colors } from "../../../theme/palette";

export const styleConfig = {
  cardContainer: {
    borderRadius: "16px",
    border: `1px solid ${colors.Gray100}`,
    background: colors.White,
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
  },
  contentSection: {
    paddingBottom: "16px",
    borderBottom: `1px solid ${colors.Gray100}`,
  },
  title: {
    color: colors.Dark1000,
    marginBottom: "8px",
  },
  detailsContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  dateContainer: {
    display: "flex",
    flexDirection: "column",
    paddingInlineEnd: "16px",
    marginInlineEnd: "16px",
    borderRight: `1px solid ${colors.Gray100}`,
    alignItems: "center",
    justifyContent: "center",
  },
  dateText: {
    color: colors.Green100,
  },
  infoContainer: {
    display: "flex",
    rowGap: "11px",
    flexDirection: "column",
    paddingInlineEnd: "16px",
    marginInlineEnd: "16px",
    justifyContent: "center",
    maxWidth: "calc(100% - 120px)",
  },
  locationRow: {
    display: "flex",
    alignItems: "center",
    columnGap: "8px",
  },
  locationText: {
    color: colors.Dark800,
    maxWidth: "200px",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    wordBreak: "break-word",
  },
  timeRow: {
    display: "flex",
    alignItems: "center",
    columnGap: "8px",
    color: colors.Dark800,
  },
  footerSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  },
  avatarGroup: {
    "& .MuiAvatar-circular": {
      fontSize: "12px",
      width: "24px",
      height: "24px",
    },
  },
  actionButtons: {
    display: "flex",
    columnGap: "16px",
  },
  manageButton: {
    width: "50%",
  },
  cancelButton: {
    width: "50%",
    borderColor: colors.Red200,
    color: colors.Red200,
    "&:hover": {
      backgroundColor: colors.Red25,
      color: colors.Red100,
      borderColor: colors.Red100,
    },
  },
  chipBase: {
    padding: "2px 12px",
    minWidth: "64px",
    height: "fit-content",
    "& .MuiChip-label": {
      padding: 0,
    },
  },
  typeChip: {
    color: colors.Dark1000,
    background: colors.SecondaryMint,
  },
  statusColors: {
    finished: colors.Dark600,
    soon: colors.Yellow200,
    active: colors.Red100,
    default: colors.Dark600,
  },
};
